module.exports = __webpack_public_path__ + "img/2.a847009.jpg";